import script from "./VInputPasswordWithLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./VInputPasswordWithLabel.vue?vue&type=script&setup=true&lang=js"

import "./VInputPasswordWithLabel.vue?vue&type=style&index=0&id=586248da&lang=css"

const __exports__ = script;

export default __exports__